import { MessageCircle, Share2, Copy } from "lucide-react";
import { toast } from "sonner";
import { sendToWhatsApp, nativeShare } from "@/lib/shoppingList";
import { Button, Card } from "@/components/kit";

export default function SharePanel({ text, title, disabled }) {
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); toast.success("Texto copiado"); } catch { toast.error("Não foi possível copiar"); }
  };
  const share = async () => { if (!(await nativeShare(text, title))) sendToWhatsApp(text); };
  return (
    <Card className="flex flex-col gap-3" data-testid="share-panel">
      <div className="h3">Enviar lista</div>
      <pre className="whitespace-pre-wrap text-[13px] leading-relaxed rounded-xl p-3 max-h-64 overflow-y-auto" style={{ background: "var(--surface-alt)", fontFamily: "inherit" }} data-testid="whatsapp-preview">{text}</pre>
      <Button icon={MessageCircle} disabled={disabled} onClick={() => sendToWhatsApp(text)} style={{ background: "#25D366" }} data-testid="send-whatsapp-button">Enviar para o WhatsApp</Button>
      <div className="grid grid-cols-2 gap-2">
        <Button variant="secondary" size="sm" icon={Share2} disabled={disabled} onClick={share} data-testid="native-share-button">Compartilhar</Button>
        <Button variant="secondary" size="sm" icon={Copy} disabled={disabled} onClick={copy} data-testid="copy-list-text-button">Copiar texto</Button>
      </div>
    </Card>
  );
}
